const data = [
  {
    title: "Muhammad Hussain & Brothers",
    Description:
      "The Company holds Category 4 Certificate of Pakistan Engineering Council and is specifically into hydel and Civil Construction Projects. The company has Constructed and Developed many projects in the rural and urban areas of Gilgit Baltistan & AJK region.",
  },
  {
    title: "Sajjad Hussain & Brothers",
    Description:
      "The Company holds Category 6 Certificate of Pakistan Engineering Council and is specifically into civil works in Gilgit Baltistan region.",
  },
  {
    title: "GM Jaffery & Sons",
    Description:
      "The Company holds Category 6 Certificate of Pakistan Engineering Council and is specifically into civil works in Gilgit Baltistan, Chitral and Azad Jamu Kashmir region.",
  },
  {
    title: "Ghullam Ali & Brothers",
    Description:
      "The Company holds Category 3 Certificate of Pakistan Engineering Council and is specifically works in hydel projects Civil/Electrical works in Gilgit Baltistan, Chitral and Azad Jamu Kashmir region.",
  },
];

export default data;
